var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-card" },
    [
      _c("div", { staticClass: "v-header" }, [
        _vm.title
          ? _c(
              "h3",
              { staticClass: "v-title" },
              [
                _vm._v("\n      " + _vm._s(_vm.title) + "\n      "),
                _vm.fourSectionAnalysis
                  ? _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "dark", placement: "top" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "line-height": "20px",
                              width: "400px"
                            },
                            attrs: { slot: "content" },
                            slot: "content"
                          },
                          [
                            _vm._v(
                              "四分位数是指处在25%位置上的数值（称为下四分位数q1）和处在75%位置上的数值（称为上四分位数q3）"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("img", {
                          staticStyle: {
                            height: "14px",
                            "vertical-align": "middle",
                            "margin-left": "5px",
                            "margin-top": "-3px"
                          },
                          attrs: { src: require("images/explain.png"), alt: "" }
                        })
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "v-center" }, [_vm._t("center")], 2),
        _vm._v(" "),
        _c("div", { staticClass: "v-footer" }, [_vm._t("footer")], 2)
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28d3c952", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28d3c952","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/VCard.vue
// module id = null
// module chunks = 